module.exports = __webpack_public_path__ + "static/Product_Tvcurved2-95b9467d4571eb58dfa7193a89eefd3d.png";